import { Box, Button, Flex, Text } from '@chakra-ui/react';
import CreateGoalTabs from '../components/CreateGoalTabs';
import { useGetGoal } from '../apis';
import { useNavigate, useParams } from 'react-router';

export const EditGoal = () => {
  const navigate = useNavigate();
  const { goalId } = useParams();
  const { data: goalData, isLoading: goalDataLoading } = useGetGoal(
    goalId as string
  );

  return (
    <Flex direction={'column'} w={'100%'} gap={1}>
      <Button
        onClick={() => navigate(-1)}
        size="sm"
        variant="link"
        w={'fit-content'}
      >
        Back
      </Button>
      <Text fontSize={'xl'} color={'text.gray.300'} fontWeight={'semibold'}>
        Edit Goal
      </Text>
      <Box mt={'24px'}>
        <CreateGoalTabs
          isEdit
          goalState={goalData}
          goalStateLoading={goalDataLoading}
        />
      </Box>
    </Flex>
  );
};

export default EditGoal;
